// WS-PROTEAM-FAQ: opens a row from a #slug link, and runs the FAQ page search. Rows and answers are server-rendered;
// without this file the page still reads top to bottom and the search box stays hidden.
(function () {
  'use strict';

  function fold(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function openHash(hash) {
    if (!hash || hash.length < 2) return;
    var el;
    try {
      el = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return;
    }
    if (el && el.tagName === 'DETAILS') {
      el.open = true;
      el.scrollIntoView({ block: 'start' });
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pt-faq__answer a[href^="#"]');
    if (a) openHash(a.getAttribute('href'));
  });
  window.addEventListener('hashchange', function () { openHash(location.hash); });
  document.addEventListener('DOMContentLoaded', function () { openHash(location.hash); });

  function initSearch(root) {
    var wrap = root.querySelector('[data-pt-faq-search]');
    var input = root.querySelector('#pt-faq-search');
    if (!wrap || !input) return;
    var status = root.querySelector('[data-pt-faq-status]');
    var none = root.querySelector('[data-pt-faq-none]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pt-faq-row]')).map(function (el) {
      return { el: el, text: fold(el.getAttribute('data-search')) };
    });
    var cats = root.querySelectorAll('[data-pt-faq-category]');
    var jump = root.querySelector('.pt-faq__jump');
    var report = null;
    wrap.hidden = false;

    function run(publish) {
      var words = fold(input.value).split(/\s+/).filter(Boolean);
      var searching = words.length > 0;
      var shown = 0;
      rows.forEach(function (r) {
        var hit = words.every(function (w) { return r.text.indexOf(w) !== -1; });
        r.el.hidden = !hit;
        if (hit) shown++;
      });
      rows.forEach(function (r) {
        r.el.open = searching && !r.el.hidden && shown <= 3;
      });
      Array.prototype.forEach.call(cats, function (c) {
        c.hidden = !c.querySelector('[data-pt-faq-row]:not([hidden])');
      });
      if (jump) jump.hidden = searching;
      if (none) none.hidden = shown !== 0;
      if (status) {
        status.textContent = searching ? (root.getAttribute('data-count-text') || '{n}').replace('{n}', shown) : '';
      }
      if (publish && searching && window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        clearTimeout(report);
        report = setTimeout(function () {
          Shopify.analytics.publish('faq_search', { term: input.value.trim().slice(0, 100), results: shown });
        }, 1200);
      }
    }

    input.addEventListener('input', function () { run(true); });
    var q = new URLSearchParams(location.search).get('q');
    if (q) {
      input.value = q;
      run(false);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-pt-faq]');
    if (root) initSearch(root);
  });
})();
